import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

const store = {
  debug: false,
  state: {
    executed: false,
    slept: false
  },
  executed (): boolean {
    this.state.executed = this.state.executed || (!this.debug && localStorage.executed == 'true');
    if (this.debug) console.log("executed: " + this.state.executed);
    return this.state.executed;
  },
  slept (): boolean {
    this.state.slept = this.state.slept || (!this.debug && localStorage.slept == 'true');
    if (this.debug) console.log("slept: " + this.state.slept);
    return this.state.slept;
  },
  execute () {
    this.state.executed = true;
    if (this.debug) {
      console.log("executed!");
      return;
    }
    localStorage.executed = true;
  },
  sleep () {
    this.state.slept = true;
    if (this.debug) {
      console.log("slept!");
      return;
    }
    localStorage.slept = true;
  }
}

new Vue({
  render: h => h(App),
  router,
  data: store
}).$mount('#app')
